export const CVSS2 = 'cvss2';
export const CVSS3 = 'cvss3';
export const CVSS4 = 'cvss4';

export const DEFAULT_CVSS_TYPE = CVSS3;

export const CVSS_TYPE_OPTIONS = [
  { label: 'CVSS v2.0', value: CVSS2 },
  { label: 'CVSS v3.1', value: CVSS3 },
  { label: 'CVSS v4.0', value: CVSS4 }
];

export const CVSS_PATTERNS = {
  [CVSS2]: /^AV:[NAL]\/AC:[LH]\/Au:[NSM]\/C:[CNP]\/I:[CNP]\/A:[CNP]$/,
  [CVSS3]: /^CVSS:3\.1\/AV:(N|A|L|P)\/AC:(L|H)\/PR:(N|L|H)\/UI:(N|R)\/S:(U|C)\/C:(N|L|H)\/I:(N|L|H)\/A:(N|L|H)$/,
  [CVSS4]: /^CVSS:4\.0\/AV:(N|A|L|P)\/AC:(L|H)\/AT:(N|P)\/PR:(N|L|H)\/UI:(N|A|R|P)\/VC:(N|L|H)\/VI:(N|L|H)\/VA:(N|L|H)\/SC:(N|L|H)\/SI:(N|L|H)\/SA:(N|L|H)(\/E:(X|U|P|A))?(\/CR:(L|M|H))?(\/IR:(L|M|H))?(\/AR:(L|M|H))?(\/MAV:(N|A|L|P))?(\/MAC:(L|H))?(\/MAT:(N|P))?(\/MPR:(N|L|H))?(\/MUI:(N|P|A))?(\/MVC:(N|L|H))?(\/MVI:(N|L|H))?(\/MVA:(N|L|H))?(\/MSC:(N|L|H))?(\/MSI:(N|L|H|S))?(\/MSI:(N|L|H|S))?(\/MSA:(N|L|H|S))?(\/S:[A-Z])?(\/AU:[A-Z])?(\/R:[A-Z])?(\/V:[A-Z])?(\/RE:[A-Z])?(\/U:[A-Za-z]+)?$/
};

export const getActiveCvssType = (vuln = {}) => {
  if (vuln?.cvss4?.vector_string) return CVSS4;
  if (vuln?.cvss3?.vector_string) return CVSS3;
  if (vuln?.cvss2?.vector_string) return CVSS2;
  return DEFAULT_CVSS_TYPE;
};

export const getCvssVectors = (vuln = {}) => ({
  [CVSS2]: vuln?.cvss2?.vector_string || '',
  [CVSS3]: vuln?.cvss3?.vector_string || '',
  [CVSS4]: vuln?.cvss4?.vector_string || ''
});

export const isValidCvssVector = (vector, type) => {
  return Boolean(vector) && CVSS_PATTERNS[type]?.test(vector);
};

export const isInvalidCvssVector = (vector, type) => {
  return Boolean(vector) && !isValidCvssVector(vector, type);
};
